var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "shopify-plan" } },
    [
      _vm.settingsFetched && _vm.settings.plan
        ? _c("div", { staticClass: "w-100" }, [
            _vm.header
              ? _c("div", { staticClass: "plan-detail" }, [
                  _c("strong", [
                    _vm._v(_vm._s(_vm.$t("billing.yourCurrentPlan")) + ": "),
                  ]),
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.settings.plan.selectedPlan.toUpperCase() +
                          " \t (" +
                          _vm.settings.plan.detail.maxAgentCount +
                          " Agent)"
                      ) +
                      "\n        "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.approvedMode && !_vm.approving
              ? _c("div", { staticClass: "plans" }, [
                  _c(
                    "div",
                    {
                      staticClass: "plan",
                      class: {
                        selected: _vm.settings.plan.selectedPlan === "free",
                      },
                    },
                    [
                      _c("div", { staticClass: "header" }, [
                        _vm._v("Free Plan"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "plan-price-section" }, [
                        _c("div", { staticClass: "plan-price-details" }, [
                          _c(
                            "span",
                            {
                              staticClass: "amount",
                              class: {
                                tl: _vm.site.basePrice.currency === "tl",
                              },
                            },
                            [_vm._v("0")]
                          ),
                          _vm._v(" "),
                          _c("i", [
                            _c("i", { staticClass: "slash" }, [_vm._v("/")]),
                            _vm._v(" "),
                            _c("i", { staticClass: "billed-month" }, [
                              _vm._v(
                                _vm._s(_vm.$t("billing.month")) +
                                  "\n                                "
                              ),
                              _c("i", { staticClass: "billed-yearly hide" }, [
                                _c("br"),
                                _vm._v(
                                  _vm._s(_vm.$t("billing.billedMonthToMonth"))
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        { staticClass: "selectAgentCount" },
                        [
                          _c(
                            "md-select",
                            {
                              attrs: {
                                autocomplete: "off",
                                value: 1,
                                disabled: "",
                              },
                            },
                            [
                              _c("md-option", { attrs: { value: 1 } }, [
                                _vm._v(
                                  " 1 " + _vm._s(_vm.$t("billing.oneAgent"))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-raised md-primary w-100",
                          staticStyle: {
                            transform: "scale(0.7)",
                            "font-size": "x-large",
                            "border-radius": "10%",
                          },
                          attrs: {
                            disabled:
                              _vm.selectPlanDisabled ||
                              _vm.settings.plan.selectedPlan === "free",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectPlan(true, 1)
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.settings.plan.selectedPlan === "free"
                                ? _vm.$t("billing.yourCurrentPlan")
                                : _vm.$t("billing.selectFreePlan")
                            ) + "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-succes" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c("a-divider", [
                        _vm._v(_vm._s(_vm.$t("billing.planDetails"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "features" }, [
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("1 " + _vm._s(_vm.$t("billing.agent"))),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.videoCallUnlimited"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.audioCallUnlimited"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.screenSharingUnlimited"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.fileTransferUnlimited"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("billing.autoChatAssignerUnlimited")
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "billing.multiLanguageTranslationUnlimited"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.detailedReporting"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("billing.fullCustomizationUnlimited")
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "plan",
                      class: {
                        selected: _vm.settings.plan.selectedPlan === "pro",
                      },
                    },
                    [
                      _c("div", { staticClass: "header" }, [
                        _vm._v("Pro Plan"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "plan-price-section" }, [
                        _c("div", { staticClass: "plan-price-details" }, [
                          _c(
                            "span",
                            {
                              staticClass: "amount",
                              class: {
                                tl: _vm.site.basePrice.currency === "tl",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.calculateAgentPrice(
                                    _vm.selectedAgentCount
                                  )
                                )
                              ),
                            ]
                          ),
                          _c("i", [
                            _c("i", { staticClass: "slash" }, [_vm._v("/")]),
                            _vm._v(" "),
                            _c("i", { staticClass: "billed-month" }, [
                              _vm._v(
                                _vm._s(_vm.$t("billing.month")) +
                                  "\n                                "
                              ),
                              _c("i", { staticClass: "billed-yearly hide" }, [
                                _c("br"),
                                _vm._v(
                                  _vm._s(_vm.$t("billing.billedMonthToMonth"))
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        { staticClass: "selectAgentCount" },
                        [
                          _c(
                            "md-select",
                            {
                              attrs: { autocomplete: "off" },
                              model: {
                                value: _vm.selectedAgentCount,
                                callback: function ($$v) {
                                  _vm.selectedAgentCount = $$v
                                },
                                expression: "selectedAgentCount",
                              },
                            },
                            _vm._l(_vm.agentCounts, function (count, i) {
                              return _c(
                                "md-option",
                                { key: i, attrs: { value: count } },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(count) +
                                      " " +
                                      _vm._s(_vm.$t("billing.agent"))
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-raised md-primary w-100",
                          staticStyle: {
                            transform: "scale(0.7)",
                            "font-size": "x-large",
                            "border-radius": "10%",
                          },
                          attrs: {
                            disabled:
                              _vm.selectPlanDisabled ||
                              (_vm.settings.plan.selectedPlan === "pro" &&
                                _vm.settings.plan.detail.maxAgentCount ===
                                  _vm.selectedAgentCount),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectPlan(
                                false,
                                _vm.selectedAgentCount
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.settings.plan.selectedPlan === "pro" &&
                                _vm.settings.plan.detail.maxAgentCount ===
                                  _vm.selectedAgentCount
                                ? _vm.$t("billing.yourCurrentPlan")
                                : _vm.$t("billing.selectProPlan")
                            ) + "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-success" }, [
                        _vm._v(_vm._s(_vm.$t("billing.days30TrialsAvailable"))),
                      ]),
                      _vm._v(" "),
                      _c("a-divider", [
                        _vm._v(_vm._s(_vm.$t("billing.planDetails"))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "features" }, [
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("billing.multiAgentUpTo", {
                                    agentCount: _vm.selectedAgentCount,
                                  })
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.videoCallUnlimited"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.audioCallUnlimited"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.screenSharingUnlimited"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.fileTransferUnlimited"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("billing.autoChatAssignerUnlimited")
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "billing.multiLanguageTranslationUnlimited"
                                  )
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.detailedReporting"))
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("billing.fullCustomizationUnlimited")
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "feature" },
                          [
                            _c("a-icon", { attrs: { type: "check" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("billing.ChatBotUnlimited"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ])
        : _c(
            "div",
            [
              _c("md-progress-spinner", {
                staticClass: "md-accent",
                attrs: { "md-diameter": 20, "md-mode": "indeterminate" },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _vm.approvedMode
        ? _c("a-result", {
            attrs: { title: _vm.$t("billing.planUpdated") },
            scopedSlots: _vm._u(
              [
                {
                  key: "icon",
                  fn: function () {
                    return [
                      _c("a-icon", {
                        attrs: { type: "smile", theme: "twoTone" },
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "extra",
                  fn: function () {
                    return [
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.approvedMode = false
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("billing.done")))]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              5684124
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.approving
        ? _c("a-alert", {
            attrs: {
              type: "success",
              "show-icon": "",
              message: _vm.$t("billing.planUpdating"),
              description: _vm.$t("billing.planUpdatingDescription"),
              banner: "",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.compareMode.enabled
        ? _c("ComparePlans", {
            attrs: {
              "new-plan": _vm.compareMode.newPlan,
              "old-plan": _vm.compareMode.oldPlan,
              "on-approved": _vm.planChangeApproved,
              "on-cancel": _vm.planChangeRejected,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }